/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

// IMPORTANT: This file must have NO imports to ensure __webpack_public_path__
// is set before any modules are evaluated. ES6 imports are hoisted, so any
// import statement would execute before the code below.

// Compute the public path from window.resourceBasePath (set by index.ejs before this script loads)
// If resourceBasePath is not set or contains unprocessed EJS template, fall back to '/'
const computedPublicPath: string =
  typeof window !== 'undefined' &&
  (window as any).resourceBasePath &&
  !(window as any).resourceBasePath.includes('<$=')
    ? (window as any).resourceBasePath
    : '/'

// Set webpack public path - this MUST be a top-level assignment for webpack to recognize it
// @ts-ignore __webpack_public_path__ is a webpack-specific free variable
__webpack_public_path__ = computedPublicPath

// Export to make this a module (prevents TypeScript from treating as global script)
export {}
